import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../../UserContext';
import SinglePostHelper from '../../compos/SinglePostHelper/SinglePostHelper';
import '../News/News.css';

const LoadingSpinner = () => (
	<div className='flex justify-center flex-col items-center h-screen bg-gray-100'>
		<div className='w-12 h-12 border-4 border-gray-400 border-dashed rounded-full animate-spin'></div>
	</div>
);

// Landing page for signed share links: /share/<id>/<hash>.
//
// Behaviour, per product spec:
//  - Logged in (auth token resolves to a session): swap the URL to the canonical
//    /getpost/<id> so the viewer gets the full, interactive post page. We pass
//    `fromShare` so that page knows back should land on the News feed.
//  - Logged out: stay here and render the post in read-only "share mode" — all
//    interactions are gated behind a login prompt and back goes Home.
function SharedPost() {
	const { id, hash } = useParams<{ id: string; hash: string }>();
	const { isLoggedIn, isAuthLoading } = useUser();
	const navigate = useNavigate();

	React.useEffect(() => {
		if (!isAuthLoading && isLoggedIn && id) {
			navigate(`/getpost/${id}`, { replace: true, state: { fromShare: true } });
		}
	}, [isAuthLoading, isLoggedIn, id, navigate]);

	// While auth is still resolving, or while a logged-in user is being redirected,
	// don't flash the read-only view.
	if (isAuthLoading || isLoggedIn) {
		return <LoadingSpinner />;
	}

	return (
		<div className='News'>
			<SinglePostHelper shareMode shareId={id} shareHash={hash} />
		</div>
	);
}

export default SharedPost;
